import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';

const ColorPicker = ({ value, onChange, testIdPrefix = 'color' }) => {
  const presets = [
    '#F97316', '#EF4444', '#F43F5E', '#EC4899', '#A855F7',
    '#8B5CF6', '#6366F1', '#3B82F6', '#06B6D4', '#14B8A6',
    '#10B981', '#22C55E', '#84CC16', '#EAB308', '#F59E0B',
    '#000000', '#64748B', '#FBBF24',
  ];

  return (
    <div className="space-y-3">
      <div className="flex items-center gap-3">
        <div className="relative">
          <input
            type="color"
            value={value}
            onChange={(e) => onChange(e.target.value)}
            data-testid={`${testIdPrefix}-picker`}
            className="w-12 h-12 rounded-lg cursor-pointer border-2 border-slate-200 dark:border-slate-600"
            style={{ padding: 0 }}
          />
        </div>
        <div className="flex-1">
          <Label className="text-xs text-muted-foreground mb-1 block">Código HEX</Label>
          <Input
            type="text"
            value={value}
            onChange={(e) => {
              const v = e.target.value;
              if (/^#[0-9A-Fa-f]{0,6}$/.test(v)) onChange(v);
            }}
            data-testid={`${testIdPrefix}-hex-input`}
            placeholder="#FF5733"
            className="font-mono text-sm"
            maxLength={7}
          />
        </div>
        <div
          className="w-12 h-12 rounded-lg border-2 border-slate-200 dark:border-slate-600 flex-shrink-0"
          style={{ backgroundColor: value }}
          data-testid={`${testIdPrefix}-preview`}
        />
      </div>
      <div className="flex flex-wrap gap-2">
        {presets.map((c) => (
          <button
            key={c}
            type="button"
            onClick={() => onChange(c)}
            className={`w-8 h-8 rounded-md border-2 transition-all ${
              value === c ? 'border-slate-900 dark:border-white scale-110' : 'border-slate-200 dark:border-slate-600 hover:border-slate-400'
            }`}
            style={{ backgroundColor: c }}
          />
        ))}
      </div>
    </div>
  );
};

export default ColorPicker;
